// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__HSARK","main":"Main_main__xnaLl","page-enter":"Main_page-enter__Z6crC"};